import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

import userQuery from "../../firestore/User.query";
import { UserData } from "../../model/Users";
import companiesQuery from "../../firestore/Companies.query";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export const SidebarWeb = () => {

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;

  const [pointFlg, setPointFlg] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const auhtLogout = async () => {
    await auth.signOut().then(() => {
      console.log("Sign-out successful.")
      sessionStorage.clear();
      navigate("/portal/login");
    })
    .catch(err => {
      console.error(err.message)
    })
  };

  const [user, setUser] = useState<UserData>();

  const selectStyles = (to: string) => {
    const pathname = location.pathname;
    const subMenuPathname = `/portal${pathname.includes('/') ? `/${pathname.split('/')[2]}` : pathname}`;
    if (subMenuPathname === to) {
      return "border-transparent bg-dark-orange-50 text-yellow-800";
    } else {
      return "border-transparent text-white hover:bg-[#FFEFE1] hover:text-yellow-800";
    }
  };

  useMemo(() => {
    (async () => {
      document.title = `ジョイン マイページ`
      // 利用者情報を取得
      const user = await userQuery.getUser(currentUser?.tenantId!, currentUser?.uid!) as UserData;
      setUser(user);
      const options = await companiesQuery.getOptionContractList(currentUser?.tenantId!);
      const pointAuth = options.find((option) => option.optionId === 'point');
      if (pointAuth?.status === true) {
        setPointFlg(true);
      }
    })();
  }, []);

  useEffect(() => {
    if(location.pathname === "/portal" || location.pathname === "/portal/"){
      /** ルートディレクトリ遷移時 */
       navigate("eventParticipationWeb");
    }
  },[location.pathname, navigate]);

  const navigation = [
    { name: "イベント参加履歴", href: "/portal/eventParticipationWeb", displayFlg: true },
    { name: "ポイント履歴", href: "/portal/pointHistoryListWeb", displayFlg: pointFlg },
    { name: "ポイント交換", href: "", displayFlg: false }
  ];

  return (
    <>
      <div className="flex">
        <div className="sticky fixed inset-y-0 flex w-56 flex-col h-[100vh] flex-shrink-0">
          <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-dark-orange-600 pt-5 shadow">
            <div className="text-xl flex flex-shrink-0 items-center px-4 font-bold tracking-tight text-white">
              ジョイン<br/>
              マイページ
            </div>
            <div className="mt-5 flex flex-grow flex-col">
              <nav className="flex-1 space-y-1 px-1 pb-4">
                {navigation.filter((item) => item.displayFlg === true).map((item) => {
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      className={classNames(
                        selectStyles(item.href),
                        "group flex items-center px-2 py-2 text-sm font-medium border-l-4"
                      )}
                    >
                      {item.name}
                    </a>
                  )
                })}
              </nav>
            </div>
          </div>
        </div>
        <div className="flex flex-col h-fit w-full">
          <div className="w-full min-w-fit">
            <div className="sticky flex top-0 z-10 h-16 flex-shrink-0 bg-dark-orange-50 shadow">
              <div className={"flex mx-5 flex-1"}>
                <h2 className={"self-center text-xl font-semibold text-gray-900"}>{user?.lastName!} 様</h2>
              </div>
              <button
                type="button"
                className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                onClick={() => {if(window.confirm('ログアウトしますか？')) auhtLogout()}}
              >
                ログアウト
              </button>
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};
